import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { UserDto } from '@/features/dashboard/users/types/UserDto.ts';
import { TableDefinitionDto } from '@/components/table/types/TableDefinitionDto.ts';
import { PageRequest } from '@/components/table/types/PageRequest.ts';
import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';
import { PagedDto } from '@/components/table/types/PagedDto.ts';
import { buildPageRequestParams } from '@/components/table/types/TableUtil.ts';
import { UserListDto } from '@/features/dashboard/users/types/UserListDto.ts';

export const usersApi = {
  getTableDefinition: async (): Promise<TableDefinitionDto> => {
    return await fetchPrivateApi<TableDefinitionDto>(
      'GET',
      `users/table-definition`,
    );
  },
  getUsers: async (
    pageRequest: PageRequest,
    filterCriteria: FilterCriteriaDto,
  ): Promise<PagedDto<UserListDto>> => {
    const params = buildPageRequestParams(pageRequest);
    return await fetchPrivateApi<PagedDto<UserListDto>>(
      'POST',
      `users/all?${params.toString()}`,
      filterCriteria,
    );
  },
  getById: async (userId: string): Promise<UserDto> => {
    return await fetchPrivateApi<UserDto>('GET', `users/${userId}`);
  },
  getByEmail: async (email: string): Promise<UserDto> => {
    return await fetchPrivateApi<UserDto>(
      'GET',
      `users/by-email?email=${encodeURIComponent(email)}`,
    );
  },
};
